<template>
    <div>
      <Head :title="__('Projects')" />
        <div class="mb-6 flex flex-col md:flex-row gap-3 justify-end items-center ticket-filters">
            <!-- <div class="filter-add-new flex flex-col gap-3 md:flex-row w-full items-center max-w-md"> -->
                <Link class="btn-indigo" :href="route('projects.create')">
                    <span>{{ __('Create New') }}</span>
                </Link>
            <!-- </div> -->
        </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">{{ __('App Name') }}</th>
            <th class="pb-4 pt-6 px-6">{{ __('Domain') }}</th>
              <th class="pb-4 pt-6 px-6">{{ __('Created') }}</th>
          </tr>
          <tr v-for="project in projects.data" :key="project.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="route('projects.edit', project.id)">
                <img v-if="project.photo" class="block -my-2 mr-2 w-5 h-5 rounded-full" :src="project.photo" />
                {{ project.app_name }}
              </Link>
            </td>
             <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="route('projects.edit', project.id)" tabindex="-1">
                {{ project.domain }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="route('projects.edit', project.id)" tabindex="-1">
                {{ project.created_at }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="route('projects.edit', project.id)" tabindex="-1">
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="projects.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="6">No projects found.</td>
          </tr>
        </table>
      </div>
        <pagination class="mt-6" :links="projects.links" />
    </div>
  </template>

  <script>
  import { Head, Link } from '@inertiajs/vue3'
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import Pagination from '@/Shared/Pagination'
  import SelectInput from '@/Shared/SelectInput'

  export default {
    components: {
      Head,
      Icon,
      Link,
        SelectInput,
        Pagination,
    },
    layout: Layout,
    props: {
      projects: Object,
    },
    data() {
      return {
        form: {},
      }
    },
    watch: {
      form: {
        deep: true,
        handler: throttle(function () {
          this.$inertia.get(this.route('projects'), pickBy(this.form), { preserveState: true })
        }, 150),
      },
    },
    methods: {
      reset() {
        this.form = mapValues(this.form, () => null)
      },
    },
  }
  </script>
